const listsMessages = {
  SEARCH_PLACEHOLDER: 'Search for lists',
  FILTER_BY_TYPE_LABEL: 'Filter by Type',
  FILTER_ALL_TYPES: 'All Types',
  TABLE_HEADER_NAME: 'Name',
  TABLE_HEADER_TYPE: 'Type',
  TABLE_HEADER_VALUES: 'Values',
  TABLE_HEADER_LAST_UPDATED_BY: 'Last Updated By',
  CREATED_BY_PREFIX: 'Created by',
  NO_LISTS_FOUND: 'No lists found',
  EMPTY_STATE_WITH_SEARCH: 'Try adjusting your search or filter criteria.',
  EMPTY_STATE_DEFAULT: 'Create your first list to get started.',
  CREATE_LIST_BUTTON: 'Create List',
  DELETE_ACTION: 'Delete',
  VALUES_MORE_SUFFIX: 'more',

  // Modal strings
  MODAL_TITLE_CREATE: 'Create New List',
  MODAL_TITLE_EDIT: 'Edit List',
  LIST_NAME_LABEL: 'List Name *',
  LIST_NAME_PLACEHOLDER: 'e.g., Document Apps, PII Data Types, Office IPs',
  LIST_NAME_REQUIRED_ERROR: 'List name is required',
  LIST_NAME_MIN_LENGTH_ERROR: 'List name must be at least 2 characters',
  CONDITION_TYPE_LABEL: 'Condition Type *',
  CONDITION_TYPE_DESCRIPTION: 'This list will only be available for the selected condition type when creating policies',
  VALUES_LABEL: 'Values *',
  VALUES_SELECTED_PREFIX: 'Selected',
  VALUES_REQUIRED_ERROR: 'At least one value is required',
  IP_ADDRESS_PLACEHOLDER: 'Enter IP address or CIDR (e.g., 192.168.1.0/24)',
  CONTENT_TYPE_DESCRIPTION: 'Select from predefined content types or type custom values',
  CONTENT_TYPE_PLACEHOLDER: 'Type or select content types (e.g., SSN, Credit Card, Custom Type)',
  SEARCH_CITIES_PLACEHOLDER: 'Type at least 3 characters to search cities...',
  SEARCH_APPS_PLACEHOLDER: 'Search applications...',
  SEARCH_CONTENT_PLACEHOLDER: 'Search content types...',
  LOADING_TEXT: 'Loading...',
  NO_CITIES_FOUND: 'No cities found matching your search',
  LOADING_APPS: 'Loading applications...',
  LOADING_CONTENT_TYPES: 'Loading content types...',
  NO_MATCHING_VALUES: 'No matching values found',
  ADD_BUTTON: 'Add',
  CANCEL_BUTTON: 'Cancel',
  SAVE_CHANGES_BUTTON: 'Save Changes',
  CREATE_LIST_MODAL_BUTTON: 'Create List',
};

export default listsMessages;